import { lazy } from 'react'
export { getAuthSession } from './api/sessionApi'
export type { AuthSession } from './api/sessionApi'
export const LoginPage = lazy(() => import('./pages/LoginPage').then((module) => ({ default: module.LoginPage })))
export const RegisterPage = lazy(() => import('./pages/RegisterPage').then((module) => ({ default: module.RegisterPage })))
export const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage').then((module) => ({ default: module.ForgotPasswordPage })))
export const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage').then((module) => ({ default: module.ResetPasswordPage })))
export const VerifyEmailPage = lazy(() => import('./pages/VerifyEmailPage').then((module) => ({ default: module.VerifyEmailPage })))
export { RequireAuth } from './components/RequireAuth'
export { RequireCreator } from './components/RequireCreator'
export { useLogout } from './hooks/useLogout'
